// Include vertical slider
const BackgroundImage = require('./components/background-image');
const ajaxPosts = require('./components/ajax-posts');
const Hamburger = require('./components/hamburger');
const FooterToggle = require('./components/footer-toggle');
const HeaderSticky = require('./components/header-sticky');
const GallerySlider = require('./components/gallery-slider');

GallerySlider.init();
BackgroundImage.init();
HeaderSticky.init();
FooterToggle.init();
Hamburger.init();

ajaxPosts.init();

/**
 * On content loaded
 */
document.addEventListener('DOMContentLoaded', function () {
	const Navigation = require('./components/navigation');
	Navigation.init();

	// Add smooth scrolling when clicking any anchor link
	document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
		anchor.addEventListener('click', function (evt) {
			evt.preventDefault();
			var href = this.getAttribute('href');
			if (href && href != '#') {
				document.querySelector(href).scrollIntoView({
					behavior: 'smooth',
				});
			}
		});
	});

	// On page scroll show/hide the navbar actions and the scroll to top button
	var navbar = document.getElementById('navbar'),
		btn = document.getElementById('scrollToTop'),
		lastScrollTop = 0;
	window.onscroll = function () {
		var st = document.documentElement.scrollTop || document.body.scrollTop;

		// Show/hide the scroll to top button
		if (btn) {
			if (st > 450) {
				btn.classList.add('d-flex');
				btn.classList.remove('d-none');
			} else {
				btn.classList.remove('d-flex');
				btn.classList.add('d-none');
			}
		}

		// Show/hide the navbar
		if (navbar) {
			// Add / remove transparency
			if (st < 15) {
				navbar.classList.remove('active');
			} else {
				navbar.classList.add('active');
			}

			// Check if the scroll top bigger than x
			if (st < 450) {
				navbar.classList.remove('hide');
				navbar.classList.add('show');
			} else {
				// Check the scroll direction
				if (st > lastScrollTop) {
					// Down scroll
					navbar.classList.remove('show');
					navbar.classList.add('hide');
				} else {
					// Upscroll
					navbar.classList.remove('hide');
					navbar.classList.add('show');
				}

				// For Mobile or negative scrolling
				lastScrollTop = st <= 0 ? 0 : st;
			}
		}
	};
	// Scroll to top function
	var scrollToTop = document.getElementById('scrollToTop');
	if (scrollToTop) {
		scrollToTop.addEventListener('click', function (evt) {
			evt.preventDefault();

			// Animated scroll
			scroll({
				top: 0,
				left: 0,
				behavior: 'smooth',
			});
		});
	}

	// Show/hide the password
	pwds = document.querySelectorAll('.js-show-hide');
	if (pwds && pwds.length) {
		pwds.forEach((pwd) => {
			pwd.addEventListener('click', function () {
				var input = this.parentNode.querySelector('input');
				if (input) {
					var type = input.getAttribute('type');
					input.setAttribute('type', type == 'password' ? 'text' : 'password');
				}
			});
		});
	}

	document.querySelectorAll('.show-more--btn').forEach(function (btn) {
		btn.addEventListener('click', function (evt) {
			evt.target.parentNode.classList.toggle('show');
		});
	});

	const acc = document.getElementsByClassName('faq-item__title');
	var i;

	for (i = 0; i < acc.length; i++) {
		acc[i].addEventListener('click', function () {
			this.classList.toggle('active');
			var panel = this.nextElementSibling;
			panel.classList.toggle('active');
			if (panel.style.maxHeight) {
				panel.style.maxHeight = null;
			} else {
				panel.style.maxHeight = panel.scrollHeight + 'px';
			}
		});
	}

	const select = document.querySelector('.js-filter-category');
	if (select) {
		select.addEventListener('click', () => {
			select.classList.toggle('active');
		});
	}

	var relatedPostsSwiper = new Swiper('.swipere-related-posts', {
		loop: true,
		slidesPerView: 'auto',
		// centeredSlides: true,
		spaceBetween: 20,
		pagination: {
			el: '.swiper-pagination',
			type: 'progressbar',
		},

		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},

		// on: {
		// 	init: function () {
		// 		updateCounter(this);
		// 	},
		// 	slideChange: function () {
		// 		updateCounter(this);
		// 	},
		// },
	});
});
